import apiFetch from '@wordpress/api-fetch';
import { Card } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { useEffect, useState } from 'react';
import Loader from '../../components/Loader';

const BoilPressBlocks = () => {
	const [ blocksStatus, setBlocksStatus ] = useState( [] );
	const [ isLoading, setIsLoading ] = useState( true );

	useEffect( () => {
		fetchBlocksStatus();
	}, [] );

	const fetchBlocksStatus = async () => {
		try {
			const response = await apiFetch( {
				path: '/boilpress/v1/blocks-status',
				headers: { 'X-WP-Nonce': boilpressApi.nonce },
			} );

			if ( Array.isArray( response ) ) {
				setBlocksStatus( response );
			} else {
				throw new Error( 'Unexpected response format' );
			}
		} catch ( error ) {
			console.error( 'Failed to fetch blocks status:', error.message );
		} finally {
			setIsLoading( false );
		}
	};

	return (
		<Card style={ { padding: '1rem' } }>
			<h2 style={ { marginTop: '0' } }>
				{ __( 'Included Blocks', 'boilpress' ) }
			</h2>
			{ isLoading ? (
				<Loader />
			) : (
				blocksStatus.map( ( block ) => (
					<ul key={ block.name }>
						{ block.name === 'boilpress/boilpress' ? (
							<li>
								{ __( 'BoilPress (main block)', 'boilpress' ) }
							</li>
						) : (
							<li>{ block.name }</li>
						) }
					</ul>
				) )
			) }
		</Card>
	);
};

export default BoilPressBlocks;
